import React, { useState, useEffect, useRef } from "react";
import queryString from "query-string";
import { Form, Progress, Alert, Input, Row, Col, Container } from "reactstrap";
import { CSSTransition } from "react-transition-group";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser, faLock } from '@fortawesome/free-solid-svg-icons'

import { useLocalization } from "../../containers/I18nProvider";
import { WithCaptcha } from '../../containers/captcha';

const LoginForm = ({ api, location, ...props }) => {
  const nodeRef = useRef(null);
  const { translate } = useLocalization();
  const [onLogin, setOnLogin] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [error, setError] = useState({
    open: false,
    message: "",
  });
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const parameters = queryString.parse(location.search);
  parameters.idp = 'cabletel';

  useEffect(() => {
    setShowForm(true)
  }, []);

  const onSubmit = async (ev) => {
    ev.preventDefault();
    setOnLogin(true)
    setError({
      open: false,
      message: "",
    })

    api.userPassLogin(
      {
        username,
        password,
      },
      parameters
    )
    .then((response) => {
        setOnLogin(false)
        window.location = parameters.redirect_uri + "?" + queryString.stringify(response);
      })
      .catch((error) => {
        const _translate = translate(error.errorCode);

        let message = "USUARIO NAO ENCONTRADO.";

        if (_translate) {
          message = _translate;
        } else if (error.details) {
          message = error.details;
        }
        setOnLogin(false)
        setError({ open: true, message: message })
      });
  }

  return (
    <CSSTransition
      in={showForm}
      timeout={300}
      classNames="formshow"
      nodeRef={nodeRef}
      unmountOnExit
    >
        <>
        <div className="login-cabletel-container" ref={nodeRef}>
          <h5>Ingrese su usuario y contraseña</h5>
          <Form onSubmit={(event) => onSubmit(event)}>
            <Container fluid={true}>
              <Row className="container-input-cabletel">
                <Col sm="10" xs="10" md="10" className="cabletel-input">
                  <Input
                    className="user-input-cabletel"
                    disabled={onLogin}
                    placeholder={translate("PlaceholderUserName")}
                    required={true}
                    tabIndex={1}
                    type="text"
                    autoCorrect="off"
                    autoCapitalize="none"
                    id="username"
                    onChange={e => setUsername(e.target.value)}
                  />
                </Col>
                <Col sm="2" xs="2" md="2" className="cabletel-icon-lbl my-auto ">
                  <FontAwesomeIcon icon={faUser} color="rgba(0,0,0,0.2)" />
                </Col>
              </Row>
            </Container>
            <Container fluid={true}>
              <Row className="container-input-cabletel">
                <Col sm="10" xs="10" md="10" className="cabletel-input">
                  <Input
                    className="pass-input-cabletel"
                    required={true}
                    disabled={onLogin}
                    placeholder={translate("PlaceholderPassword")}
                    tabIndex={1}
                    type="password"
                    autoCorrect="off"
                    autoCapitalize="none"
                    id="password"
                    onChange={e => setPassword(e.target.value)}
                  />
                </Col>
                <Col sm="2" xs="2" md="2" className="cabletel-icon-lbl my-auto ">
                  <FontAwesomeIcon icon={faLock} color="rgba(0,0,0,0.2)" />
                </Col>
              </Row>
            </Container>
            {!onLogin ? (
              <button
                block={!parameters.failureRedirect}
                tabIndex={1}
                type="submit"
                id="submmit"
                className="enter-cabletel btn-lg btn-block"
                disabled={!props.turnstileSuccess}
              >
                {translate("ButtonEnter")}
              </button>
            ) : (
              <Progress animated color="danger" value={100} />
            )}
            <div className="messages-container">
              <Alert
                color="danger"
                id="error-message"
                isOpen={error.open}
                toggle={() => setError({ open: false })}
              >
                {error.message}
              </Alert>
            </div>
          </Form>
        </div>
        </>
    </CSSTransition>
  );
}

export default WithCaptcha(LoginForm, { style: { marginTop: '2rem' } });
